import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Metadata from '../../helpers/metadata/Metadata';
import anime from 'animejs';
import dataModel from '../../models/DataModel';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import WaitSpinner from '../WaitSpinner';
import closeButton from '../../assets/images/cancel-icon-gray.svg';
import csIcon from '../../assets/images/cs-photo-empty.svg';

import './PhotoCarouselPopup.scss';

export class PhotoCarouselPopup extends Component {
  
  constructor(props) {
    PhotoCarouselPopup.propTypes = {
      item: PropTypes.object,
      closeCarousel: PropTypes.func,
      projectId: PropTypes.number,
    };

    super(props);
    this.state = {
      attachments: props.item.attachments,
      currentAttachment: props.item.attachments ? props.item.attachments[0] : null,
      selectedIndex: 0,
    };
    this.createPhotos = this.createPhotos.bind(this);
    this.createPips = this.createPips.bind(this);
    this.handleArrowLeft = this.handleArrowLeft.bind(this);
    this.handleArrowRight = this.handleArrowRight.bind(this);    
    this.closeCarousel = this.closeCarousel.bind(this);
    this.goToProject = this.goToProject.bind(this);

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    this.handleClickOutside = event => {
      if (
        this.componentRef &&
        !this.componentRef.contains(event.target) &&
        !event.target.className.includes('left-arrow') &&
        !event.target.className.includes('right-arrow')
      ) {
        this.closeCarousel(event);
      }
    };
    document.addEventListener('click', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.item && prevProps.item != this.props.item) {
      this.setState({ 
        attachments: this.props.item.attachments,
        currentAttachment: this.props.selectedAttachment ? this.props.selectedAttachment : this.props.item.attachments && this.props.item.attachments[0],
      });
    }
  }

  createPhotos() {
    const { attachments } = this.state;
    const { width, isFullPage } = this.props;
    
    return attachments.map(attachment => {
      let titleImage = attachment && attachment.name? attachment.name.split('/'):'';
      
      let src;
      if (attachment.prefetchedImage && dataModel.isOffline) {
        src = attachment.prefetchedImage;
      } else if (attachment.upload && (attachment.upload instanceof Blob)) {
        src = URL.createObjectURL(attachment.upload);
      } else {
        src = dataModel.mobileBridge.isMobile ? (attachment._thumbnailForRetention && attachment._thumbnailForRetention.src ? attachment._thumbnailForRetention.src : attachment.upload) : attachment.upload;
      }
      return (
        <article 
          className='photo-display' 
          key={'photo-display-' + attachment.id}
          style={isFullPage && width ? { width, height: '100%' } : {} }
        >
          <h1>{titleImage.length>0? titleImage[titleImage.length-1]: attachment.name}</h1>
          <img src={src} alt="Upload"/>
          <div className='attachment-metadata'>
            {
              Metadata.createMetadataPhotoDisplay(attachment)
            }
          </div>
        </article>
      );
    });
  }

  createPips() {
    const { attachments, currentAttachment } = this.state;
    let pips = null;
    if (attachments.length > 1) {
      const innerPips = attachments.map(attachment => {
        return (
          <div 
            className={'pip' + (currentAttachment && currentAttachment.id == attachment.id ? ' selected' : '')} 
            key={attachment.id} 
          />
        );
      });
      pips = <div className="attachment-pips" key={'pips'}>{innerPips}</div>;
    }
    return pips;
  }

  handleArrowLeft(e) {
    e.stopPropagation();

    const { isFullPage, width } = this.props;
    const leftPosition = +this.photoCarouselInner.style.left.split('px')[0]; 

    anime({
      targets: '.photo-carousel-inner',
      left: leftPosition + (isFullPage && width ? width : 480),
      easing: 'easeInOutCubic',
      duration: 500,
      begin: () => {},
    });

    const nextIndex = this.state.selectedIndex - 1;

    this.setState({ 
      selectedIndex: nextIndex,
      currentAttachment: this.state.attachments[nextIndex],
    });
  }

  handleArrowRight(e) {
    e.stopPropagation();

    const { isFullPage, width } = this.props;
    const leftPosition = +this.photoCarouselInner.style.left.split('px')[0]; 
    
    anime({
      targets: '.photo-carousel-inner',
      left: (leftPosition - (isFullPage && width ? width : 480)),
      easing: 'easeInOutCubic',
      duration: 500,
      begin: () => { },
    });

    const nextIndex = this.state.selectedIndex + 1;

    this.setState({
      selectedIndex: nextIndex,
      currentAttachment: this.state.attachments[nextIndex],
    });
  }

  goToProject() {
    const { projectId, task, item }  = this.props;
    this.analyticsLogger.logManagerDashboardEvent('ProjectAnalysisReportingDrilldown');
    this.props.history.push('/projects/' + projectId + '/build/' + task.build_id + '/task/' + item.task_id);
  }

  closeCarousel(e) {
    e.stopPropagation();
    const { closeCarousel } = this.props;
    if (closeCarousel) {
      closeCarousel();
    }
  }

  determinePopupPosition() {
    let { top, left } = this.props;
    const { innerHeight, innerWidth } = window;

    if ((top + 440) > innerHeight) {
      const heightOffset = top + 440 - innerHeight;
      top -= heightOffset;
    }
    
    if ((left + 480) > innerWidth) {
      const widthOffset = left + 480 - innerWidth;
      left -= widthOffset;
    }

    const popupStyle = { position: 'fixed', top: (top / 2), left: (left + 10) };    

    return popupStyle;
  }

  render() {
    const { attachments, selectedIndex } = this.state;
    const { isFullPage, top, height, width, borderRadius, position } = this.props;

    const popupStyle = isFullPage ? { 
      position: position ? position : 'fixed', 
      top: top ? top : 0, 
      left: 0, 
      width: width, 
      height: height,
      'borderRadius': borderRadius ? 4 : 0,
    } : this.determinePopupPosition();

    if (!attachments) {
      return (
        <article 
          className='PhotoCarouselPopup'
          ref={el => this.componentRef = el}
          style={popupStyle}
        >
          <div className='spinner-container'>
            <WaitSpinner />
          </div>
        </article>
      );
    }
    
    let leftArrow, rightArrow;
    if (attachments.length > 1 && selectedIndex > 0) {
      leftArrow = <div className="arrow left-arrow" onClick={this.handleArrowLeft} />;
    }
    if (attachments.length > 1 && selectedIndex < attachments.length - 1) {
      rightArrow = <div className="arrow right-arrow" onClick={this.handleArrowRight} />;
    }

    const photos = this.createPhotos();
    const innerPopupStyle = { width: (attachments.length * 480) };

    return (
      <article 
        className='PhotoCarouselPopup'
        ref={el => this.componentRef = el}
        style={popupStyle}
      >
        { leftArrow }
        { rightArrow }
        <img 
          className='close-button' 
          src={closeButton} 
          alt='close' 
          onClick={this.closeCarousel}
        />
        <div 
          className="photo-carousel-inner" 
          id="photo-carousel-inner" 
          ref={el => this.photoCarouselInner = el}
          style={innerPopupStyle}
        >
          { photos }
        </div>
        {
          this.createPips()
        }
        {
          !attachments.length &&
          <div className='completion-step-not-acted-on'>
            <img 
              className='completion-step-image'
              src={csIcon}
              alt="Completion Step"
            />
            <h2 className='completion-step-text'>
              This Completion Step has not been acted upon.
            </h2>
          </div>
        }
        <button className='go-to-details' onClick={this.goToProject}>
          View Details
        </button>
      </article>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(PhotoCarouselPopup));



// WEBPACK FOOTER //
// ./src/components/PhotoCarouselPopup/index.js